import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../services/auth.services'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { emailValidator, validateAllFormFields } from '../../../models/customValidators'
import { RestServices } from '../../services/rest.services'

@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['../promotion.component.css'],
})
export class ContactComponent implements OnInit {

    en = {}
    showEN = true
    apply = false
    str: any
    statusEmail: string
    contactFormGroup: FormGroup
    statusSubmit = false

    constructor(private auth: AuthService, private formBuider: FormBuilder, private checkFormat: RestServices) {
        this.validatorForm()
    }

    ngOnInit() {
    }

    changeLanguage() {
        return this.en = this.auth.showLang(this.showEN)
    }

    validatorForm() {
        this.contactFormGroup = this.formBuider.group({
            email: ['', [Validators.required, emailValidator()]],
            clinic: ['', [Validators.required]],
            location: ['', [Validators.required]],
            name: ['', [Validators.required]],
            phone: [''],
            comment: [''],
            organizationId: ['']
        })
    }

    // check format email server
    checkFormatEmail() {
        const format = this.contactFormGroup.value.email.slice(this.contactFormGroup.value.email.search('@') + 1)
        this.checkFormat.http_post('form/checkMx', { host: format }).subscribe(
            response => {
                this.str = response['status']
            },
        )
    }

    // message valid
    // remove (|| this.contactFormGroup.get(field).dirty && (this.contactFormGroup.get(field).status === 'INVALID'))
    isFieldValid(field: string) {
        if (this.statusSubmit === true) {
            return !this.contactFormGroup.get(field).valid && this.contactFormGroup.get(field).touched // remove (!this.contactFormGroup.get(field).valid && this.contactFormGroup.get(field).touched || ))
        } else {
            return this.contactFormGroup.get(field).dirty && (this.contactFormGroup.get(field).status === 'INVALID') // remove (!this.contactFormGroup.get(field).valid && this.contactFormGroup.get(field).touched || ))
        }
    }

    // message css
    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
        }
    }

    // submit
    onSubmit() {
        if (this.contactFormGroup.valid) {
            this.apply = true
        } else {
            validateAllFormFields(this.contactFormGroup)
            this.statusSubmit = true
        }
    }

    // submit apply
    submitApply() {
        const lang = (localStorage.getItem('lang') === 'true') ? 'en' : 'ja'
        const body = {
            data: {
                clinic: this.contactFormGroup.value.clinic,
                comment: this.contactFormGroup.value.comment,
                email: this.contactFormGroup.value.email,
                location: this.contactFormGroup.value.location,
                name: this.contactFormGroup.value.name,
                phone: this.contactFormGroup.value.phone,
                organizationId: this.contactFormGroup.value.organizationId,
                type: 'contact',
            },
            lang: lang,
            type: 'contact',
        }
        this.checkFormat.http_post('form', body).subscribe(
            success => {
                this.statusEmail = success['status']
            },
        )
    }

    // back form
    reset() {
        this.apply = false
        this.statusEmail = 'no'
    }
}



// WEBPACK FOOTER //
// ./src/app/promotion/contact/contact.component.ts